import React from 'react';
export function Footer() {
  return <footer className="bg-night px-3 py-3 text-center sm:px-6" data-id="element-63" data-mp="32wd2qgad7ltj">
      <p className="mx-auto max-w-2xl text-[0.65rem] leading-relaxed text-white/60 sm:text-xs" data-id="element-64" data-mp="3gfiu2hdxs9dl">
        © 2026 NEUROLOGY VISUAL ATLAS™ — All Rights Reserved. NEUROLOGY VISUAL
        ATLAS™ is an educational study and reference resource. It does not
        replace formal medical education, supervised clinical training,
        institutional protocols, professional medical judgment or
        patient-specific evaluation.
      </p>
      <p className="mt-1 text-[0.65rem] text-white/70 sm:text-xs" data-id="element-65" data-mp="37xyao5wgelp">
        <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-66" data-mp="3ldalzbekzvhs">
          Terms &amp; Conditions
        </a>{' '}
        •{' '}
        <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-67" data-mp="3qf9rorxsn4hw">
          Privacy Policy
        </a>{' '}
        • Contact Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-68" data-mp="2ezuupo5l4cms">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}